module.exports = __webpack_public_path__ + "899c8f78ce650d4009d42443897aa723.woff2";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Regular.woff2
// module id = 368
// module chunks = 0